import {
  SearchQueryTermType,
  SearchQueryTermWithoutPositions,
} from '@neptune/compound-search-domain';
import {
  CompoundSearchCriterion,
  CompoundSearchCriterionType,
} from '@neptune/recent-searches-domain';

export function fromCriterionsToTerms(
  criterions: CompoundSearchCriterion[],
): SearchQueryTermWithoutPositions[] {
  return criterions.map((criterion) =>
    buildSearchQueryTerm(getTermTypeFromCriterion(criterion), criterion.value),
  );
}

export function fromTermsToCriterions(
  terms: SearchQueryTermWithoutPositions[],
): CompoundSearchCriterion[] {
  return terms.map(({ type, value }) => ({
    type: mapTermTypeToCriterionType(type),
    value,
  }));
}

function mapTermTypeToCriterionType(type: SearchQueryTermType): CompoundSearchCriterionType {
  if (type === SearchQueryTermType.CRITERION) {
    return 'regex';
  }

  if (type === SearchQueryTermType.GROUP_START) {
    return 'lparen';
  }

  if (type === SearchQueryTermType.GROUP_END) {
    return 'rparen';
  }

  return 'operator';
}

export function getTermTypeFromCriterion({ type }: CompoundSearchCriterion): SearchQueryTermType {
  if (type === 'regex') {
    return SearchQueryTermType.CRITERION;
  }

  if (type === 'lparen') {
    return SearchQueryTermType.GROUP_START;
  }

  if (type === 'rparen') {
    return SearchQueryTermType.GROUP_END;
  }

  return SearchQueryTermType.OPERATOR;
}

export function buildSearchQueryTerm(
  type: SearchQueryTermType,
  value: string,
): SearchQueryTermWithoutPositions {
  return {
    type,
    value,
  };
}
